import { render, staticRenderFns } from "./SingleColorSinglePlanetSlide.vue?vue&type=template&id=3d9c4d82"
import script from "./SingleColorSinglePlanetSlide.vue?vue&type=script&lang=js"
export * from "./SingleColorSinglePlanetSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d9c4d82')) {
      api.createRecord('3d9c4d82', component.options)
    } else {
      api.reload('3d9c4d82', component.options)
    }
    module.hot.accept("./SingleColorSinglePlanetSlide.vue?vue&type=template&id=3d9c4d82", function () {
      api.rerender('3d9c4d82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/teacher/vue/slides/SingleColorSinglePlanetSlide.vue"
export default component.exports